import { render } from "./Channels.vue?vue&type=template&id=6108534b&scoped=true&ts=true"
import script from "./Channels.vue?vue&type=script&lang=ts"
export * from "./Channels.vue?vue&type=script&lang=ts"

import "./Channels.vue?vue&type=style&index=0&id=6108534b&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6108534b"]])

export default __exports__